<template>
  <div :style="`height: ${contentHeight};`" class="pa-4 overflow--y">
    <!-- <div v-if="hasRole('project', 'ROLE_GET_PROJECT_ID')"> -->
    <div v-if="true">
      <div class="mb-2">
        <div class="item__label text--capitalize">{{ $t('Common.company') }}</div>
        <div>01 - Nome da empresa</div>
        <!-- <div v-else>N/A</div> -->
      </div>

      <div class="mb-2">
        <div class="item__label">{{ $t('Views.IncentivesPage.discountType') }}</div>
        <div>Percentual</div>
        <!-- <div v-else>N/A</div> -->
      </div>

      <div class="mb-2">
        <div class="item__label">{{ $t('Views.IncentivesPage.approver') }}</div>
        <div>Nome completo</div>
        <!-- <div v-else>N/A</div> -->
      </div>

      <div class="mb-2">
        <div class="item__label">{{ $t('Views.IncentivesPage.requester') }}</div>
        <div>Nome completo</div>
        <!-- <div v-else>N/A</div> -->
      </div>

      <div class="mb-2">
        <div class="item__label">{{ $t('Views.IncentivesPage.incentiveCreationDate') }}</div>
        <div>{{ '2021-01-01' | formatDate('DD/MM/YYYY') }}</div>
        <!-- <div v-else>N/A</div> -->
      </div>

      <div class="mb-2">
        <div class="item__label">{{ $t('Views.IncentivesPage.ridesAmount') }}</div>
        <div>10</div>
        <!-- <div v-else>N/A</div> -->
      </div>

      <div class="mb-2">
        <div class="item__label">{{ $t('Views.IncentivesPage.discountUpdated') }}</div>
        <div>Sim</div>
        <!-- <div v-else>N/A</div> -->
      </div>
    </div>

    <EmptyState
      v-else
      image="employee"
      :imageSize="120"
      class="px-4"
    >
      <span class="state__text">{{ $t('Views.ReportsPage.withoutPermission') }}</span>
    </EmptyState>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole, isArray, calcContentHeight } from 'utils/functions'
import EmptyState from 'components/EmptyState'

export default {
  name: 'Preview',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    EmptyState
  },
  computed: {
    ...mapState({
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.incentivesPage.preview',
      contentHeight: 'none'
    }
  },
  methods: {
    isValidArray (val) {
      return isArray(val)
    },

    hasRole (group, role) {
      return hasRole(group, role)
    },

    calcContentHeight () {
      this.contentHeight = `${calcContentHeight()}px`
    },

    handleEditProject () {
      this.$emit('toggleAction', 'edit')
    },

    change (drawer, data) {
      this.$emit('change', {
        drawer: {
          type: drawer.type,
          action: drawer.action
        },
        data: {
          id: data.id,
          name: data.name
        }
      })
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.container__title {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 800;
}
</style>
